import { AxiosError } from "axios";
import { z } from "zod";

import type { UpdateControlPoliciesErrorPayload } from "api/generated/model";
import { STATUS_CODE_ERROR_OPERATION_FAILED } from "utils/errorCodes";

const segregationOfDutiesRefusalSchema = z.object({
    type: z.literal("SegregationOfDutiesViolated") satisfies z.ZodType<
        UpdateControlPoliciesErrorPayload["type"]
    >,
});

export function isSegregationOfDutiesRefusal(error: unknown): boolean {
    return (
        error instanceof AxiosError &&
        error.response?.status === STATUS_CODE_ERROR_OPERATION_FAILED &&
        segregationOfDutiesRefusalSchema.safeParse(error.response.data).success
    );
}
